import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ArianeNavComponent } from 'src/app/layout/ariane-nav/ariane-nav.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { FilterControlsComponent } from '../consultation/filter-controls/filter-controls.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { PagedResultDTO } from '@models/shared';
import { BehaviorSubject, map, Observable, of, take } from 'rxjs';
import { DemandeType } from '@models/enums';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { AgentsService } from 'src/app/core/services/agents.service';
import { AnnuairePosteFilterParams } from '@models/api/requests';
import { PostesService } from 'src/app/core/services/postes.service';
import { DateTime } from 'luxon';
import { ReferentielsService } from 'src/app/core/services/referentiels.service';
import { environment } from 'src/environments/environment';
import { DataTableOptimizedComponent } from 'src/app/shared/data-table-optimized/data-table-optimized.component';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';
import { MAT_RADIO_DEFAULT_OPTIONS } from '@angular/material/radio';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { CustomLuxonDateAdapter } from 'src/app/shared/utils/custom-luxon-date-adapter';
import { MY_FORMATS } from 'src/app/shared/utils/date-pickr-custom-luxon-format';
import { Router } from '@angular/router';
import { ExcelService } from 'src/app/core/services/excel.service';
import { DetailAnnuairePosteComponent } from './detail-annuaire-poste/detail-annuaire-poste.component';
import { ToastrDownloadService } from 'src/app/services/toastr-download.service';
import { ToastrService } from 'ngx-toastr';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { ConsultationAnnuairesFilterComponent } from './consultation-annuaires-filter/consultation-annuaires-filter.component';

@Component({
  selector: 'app-consultation-annuaire-poste',
  imports: [
    CommonModule,
    ArianeNavComponent,
    MatDividerModule,
    MatIconModule,
    MatExpansionModule,
    MatInputModule,
    MatButtonModule,
    ConsultationAnnuairesFilterComponent,
    DataTableOptimizedComponent,
    MatSnackBarModule
  ],
  templateUrl: './consultation-annuaire-poste.component.html',
  styleUrls: ['./consultation-annuaire-poste.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    { provide: DateAdapter, useClass: CustomLuxonDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    {
      provide: MAT_RADIO_DEFAULT_OPTIONS,
      useValue: { color: 'primary' }
    }
  ]
})
export class ConsultationAnnuairePosteComponent implements OnInit {
  arianeLabel: string = 'Consultation annuaire des postes';
  arianeIcon: string = 'quick_reference_all';
  arianeList = [
    {
      label: 'Consultation annuaire des postes',
      url: '/pama/consultation-annuaire-poste'
    }
  ];
  pipe = new DatePipe(/*'fr-FR'*/ 'en-US');
  dataJSON: any[] = [];
  //dataTable_listeAgents: any[] = [];
  totalRecords_HS: number = 0;

  length: number;
  panelOpenState: boolean = false;
  filtrer_libelle$: Observable<any> = of('Filtrer');
  filterSubject = new BehaviorSubject<AnnuairePosteFilterParams | null>({
    agent: null,
    direction: null,
    service: null,
    structureHierarchique: null,
    matriculeAgent: null,
    intitulePoste: null,
    numeroPoste: null,
    posteBudgete: null,
    vacantPourvu: null,
    ageAgent: null,
    fonction: null,
    tauxEmploi: null,
    categorieGrade: null,
    typeCT: null,
    agentRemplace: null,
    dateDebutContrat: null,
    dateFinContrat: null,
    nombreAgent: null
  });
  categoriePosteList: any[] = [];
  typeContratList: any[] = [];
  listStructures: any[] = [];
  activeFilterCount$: Observable<number>;
  demandesDisplayedColumns: string[] = [
    'Agent',
    'Direction',
    'Service',
    'Structure',
    "Matricule de l'agent",
    'Intitulé du poste',
    'Numéro de poste',
    'Poste budgété 2025',
    'Vacant ou Pourvu',
    "Age de l'agent",
    'Fonction',
    'Taux d’emploi',
    'Etat du poste',
    'Catégorie grade',
    'Type contrat',
    'Agent remplacé',
    'Début-fin contrat',
    'NB agent sur poste',
    'Actions'
  ];

  // demandesDisplayedColumns: string[] = [
  //   'Agent',
  //   'Structure hiérarchique',
  //   'Fonction',
  //   'Dernier retour dir (Maxi FC)',
  //   'Début-fin contrat',
  //   'Info service',
  //   'Date entrée organisation',
  //   'Poste budgété 2025',
  //   'Type CT',
  //   'Code engagement',
  //   'Info poste',
  //   'Agt remplacé',
  //   'Date expiration carte séjour',
  //   'Catégorie poste',
  //   'Grade',
  //   'Taux sit.admin',
  //   'Actions'
  // ];

  demandesCellStyleCss: any = {
    'Numéro de poste': { 'text-align': 'center' },
    Statut: { 'text-align': 'center' },
    'Catégorie grade': { 'text-align': 'center' },
    'NB Agent': { 'text-align': 'center' }
  };

  formatDate(date: string) {
    const ma_date = DateTime.fromISO(date);
    return ma_date.isValid ? ma_date.toFormat('dd/MM/yyyy') : '';
  }

  constructor(
    private readonly agentService: AgentsService,
    private readonly posteService: PostesService,
    private readonly detectorRef: ChangeDetectorRef,
    private readonly referentielsService: ReferentielsService,
    public dialog: MatDialog,
    private readonly formBuilder: FormBuilder,
    private readonly router: Router,
    private readonly excelService: ExcelService,
    private readonly toastrService: ToastrService,
    private readonly toastrDownloadService: ToastrDownloadService,
    private readonly snackBar: MatSnackBar
  ) {
    //Prise en compte des valeurs nulles, indéfinies ou vides
    this.activeFilterCount$ = this.filterSubject.pipe(
      map((filter) => Object.entries(filter ?? {}).filter(([_, value]) => value !== null && value !== undefined && value !== '').length)
    );
  }
  ngOnInit() {
    // this.getAgentsList(0, 10).subscribe();
    this.getAnnuairePoste(0, 10).subscribe();
    this.loadListCategoriePoste();
    this.loadListTypeContrat();

    // this.toastrDownloadService.showToast('Export en cours');
  }

  togglePanel() {
    this.panelOpenState = !this.panelOpenState;
  }

  onFilterApplied(formValues: any) {
    const filterParams: AnnuairePosteFilterParams = {
      agent: formValues.agent?.id || null,
      fonction: formValues.fonction || null,
      matriculeAgent: formValues.matriculeAgent || null,
      structureHierarchique: formValues.structureHierarchique || null,
      dateDebutContrat: formValues.dateDebutContrat || null,
      dateFinContrat: formValues.dateFinContrat || null,
      service: formValues.service?.id || null,
      direction: formValues.direction?.id || null,
      posteBudgete: formValues.posteBudgete !== '' ? formValues.posteBudgete : null,
      vacantPourvu: formValues.vacantPourvu !== '' ? formValues.vacantPourvu : null,
      typeCT: formValues.typeCT?.id || null,
      numeroPoste: formValues.numeroPoste?.code || null,
      intitulePoste: formValues.intitulePoste?.libelle || null,
      agentRemplace: formValues.agentRemplace?.nom || null,
      categorieGrade: formValues.categoriePoste?.id || null,
      tauxEmploi: formValues.tauxEmploi !== null && formValues.tauxEmploi !== '' ? Number(formValues.tauxEmploi) : null,

      nombreAgent: formValues.nombreAgent || null,
      ageAgent: formValues.ageAgent || null
    };

    this.filterSubject.next(filterParams);
  }

  // getAgentsList = (pageIndex: number, pageSize: number, filter?: FilterParams): Observable<PagedResultDTO<any>> => {
  //   return this.agentService.getAllAgentWithParams(pageIndex, pageSize).pipe(
  //     map((response) => {

  //       this.length = response.totalRecords;
  //       this.detectorRef.detectChanges();
  //       return {
  //         ...response,
  //         results: this.transformDataListeAgent(response.results)
  //       };
  //     })
  //   );
  // };

  getAnnuairePoste = (pageIndex: number, pageSize: number, filter?: AnnuairePosteFilterParams): Observable<PagedResultDTO<any>> => {
    return this.posteService.getAnnuairePoste(pageIndex, pageSize, filter).pipe(
      map((response) => {
        console.log('liste annuaire poste', response);
        this.length = response.totalRecords;
        this.detectorRef.detectChanges();
        return {
          ...response,
          results: this.transformDataListePoste(response.results)
        };
      })
    );
  };

  loadListCategoriePoste() {
    this.referentielsService
      .getCategoriePoste()
      .pipe(take(1))
      .subscribe((data: any[]) => {
        if (data) {
          this.categoriePosteList = data.filter((o) => o.libelle && o.libelle.trim() !== '');
        }
      });
  }
  loadListTypeContrat() {
    this.referentielsService
      .getTypeContrat()
      .pipe(take(1))
      .subscribe((data: any[]) => {
        if (data) {
          this.typeContratList = data.filter((o) => o.libelle && o.libelle.trim() !== '');
        }
      });
  }
  transformDataListePoste(data: any[]): any {
    return data.map((poste) => {
      const _agent: any = poste?.detenteurs;
      let agent_nom = '';
      let code_poste = poste?.numero || '';
      let ageDetenteur = '';
      let fonction = '';
      let taux_emploi = poste?.tauxEmploi || '';
      let type_contrat: any;
      let agent_remplace = '';
      let debut_fin_contrat = '';
      let structure = '';
      let nb_agent = _agent.length;
      let matricule_agent = '';

      if (_agent.length > 0) {
        let detenteur = _agent[0];
        agent_nom = _agent.map((agent: any) => `${agent?.nom || ''} ${agent?.prenom || ''}`.trim()).join(' \n ');
        //code_poste = `${detenteur?.codePoste || ''}`;
        fonction = `${detenteur?.fonction || ''}`;
        debut_fin_contrat =
          detenteur?.dateDebutContrat && detenteur?.dateFinContrat
            ? this.formatDate(detenteur.dateDebutContrat) + ' ' + this.formatDate(detenteur.dateFinContrat)
            : '';
        type_contrat = detenteur?.typeContrat || null;
        matricule_agent = detenteur?.matricule || '';
        structure = `${detenteur?.libelleStructure || ''}`;
        agent_remplace = detenteur?.agentRemplace ? detenteur?.agentRemplaceNom : '';

        // calcul de l'âge d'après la date de naissance
        if (detenteur?.dateNaissance) {
          let dateDebut = DateTime.fromISO(detenteur?.dateNaissance).setLocale('fr');
          let dateFin = DateTime.fromJSDate(new Date()).setLocale('fr');
          ageDetenteur = dateFin.diff(dateDebut, ['years', 'months', 'days', 'hours']).years + '';
        }
      }

      return {
        id: poste?.id,
        Agent: agent_nom,
        Direction: poste?.direction?.libelle,
        Service: poste?.serviceFonctionnel?.libelle || null,
        "Matricule de l'agent": matricule_agent,
        Structure: structure,
        'Intitulé du poste': poste?.libelle ? `${poste.libelle}` : null,
        // 'Numéro de poste': code_poste,
        'Numéro de poste': code_poste,
        'Poste budgété 2025': poste.budgete ? 'Oui' : 'Non',
        'Vacant ou Pourvu': poste?.occupation || '',
        "Age de l'agent": ageDetenteur || '',
        Fonction: fonction,
        'Taux d’emploi': taux_emploi,
        'Etat du poste': poste?.etat,
        'Catégorie grade': poste.categoriePoste?.code || null,
        'Type contrat': this.getTypeContratLabel(type_contrat) || null,
        'Agent remplacé': agent_remplace,
        'Début-fin contrat': debut_fin_contrat,
        'NB agent sur poste': nb_agent,
        detenteurs: poste?.detenteurs ?? []
      };
    });
  }

  transformDataListePosteForExport(data: any[]): any {
    return data.map((poste) => {
      const _agent: any = poste?.detenteurs;
      let agent_nom = '';
      let code_poste = '';
      let ageDetenteur = '';
      let fonction = '';
      let taux_emploi = poste?.tauxEmploi || '';
      let type_contrat: any;
      let agent_remplace = '';
      let debut_fin_contrat = '';
      let structure = '';
      let nb_agent = _agent.length;

      if (_agent.length > 0) {
        let detenteur = _agent[0];
        agent_nom = _agent.map((agent: any) => `${agent?.nom || ''} ${agent?.prenom || ''}`.trim()).join(', ');
        code_poste = `${detenteur?.codePoste || ''}`;
        fonction = `${detenteur?.fonction || ''}`;
        debut_fin_contrat =
          detenteur?.dateDebutContrat && detenteur?.dateFinContrat
            ? this.formatDate(detenteur.dateDebutContrat) + ' - ' + this.formatDate(detenteur.dateFinContrat)
            : '';
        type_contrat = detenteur?.typeContrat || null;
        structure = `${detenteur?.libelleStructure || ''}`;
        agent_remplace = detenteur?.agentRemplace ? detenteur?.agentRemplaceNom : '';

        // calcul de l'age d'après la date de naissance
        if (detenteur?.dateNaissance) {
          let dateDebut = DateTime.fromISO(detenteur?.dateNaissance).setLocale('fr');
          let dateFin = DateTime.fromJSDate(new Date()).setLocale('fr');
          ageDetenteur = dateFin.diff(dateDebut, ['years', 'months', 'days', 'hours']).years + '';
        }
      }

      return {
        Agent: agent_nom,
        Direction: poste?.direction?.libelle,
        Service: poste?.serviceFonctionnel?.libelle || null,
        Structure: structure,
        'Intitulé du poste': poste?.libelle ? `${poste.libelle}` : null,
        'Numéro de poste': code_poste,
        'Poste budgété 2025': poste.posteOccupeObj?.budgete ? 'Oui' : 'Non',
        'Vacant ou Pourvu': poste?.occupation || '',
        "Age de l'agent": ageDetenteur || '',
        Fonction: fonction,
        'Taux d’emploi': taux_emploi,
        'Etat du poste': poste?.etat,
        'Catégorie grade': poste.categoriePoste?.code || null,
        'Type contrat': this.getTypeContratLabel(type_contrat) || null,
        'Agent remplacé': agent_remplace,
        'Début-fin contrat': debut_fin_contrat,
        'NB agent sur poste': nb_agent
      };
    });
  }
  formatDateSimple(date: null | undefined): string {
    if (!date) {
      return 'Non défini';
    }

    let _date = DateTime.fromISO(date, { zone: 'Europe/Paris' });

    if (!_date.isValid) {
      _date = DateTime.fromFormat(date, 'yyyy-MM-dd', { zone: 'Europe/Paris' });

      if (!_date.isValid) {
        console.error('Invalid date format:', date);
        return 'Date invalide';
      }
    }

    return _date.toFormat('dd/MM/yyyy');
  }

  getCategoriePosteLabel(id: number): string {
    const categorie = this.categoriePosteList.find((c) => c.id === id);
    return categorie ? categorie.libelle : '';
  }

  getTypeContratLabel(id: number): string {
    const typeContrat = this.typeContratList.find((t) => t.id === id);
    return typeContrat ? typeContrat.libelle : '';
  }

  renouvelerContrat(event: any) {
    if (event?.id) {
      this.router.navigate(['/pama/renouvellement'], { queryParams: { agentId: event.id } });
    }
  }

  exportAnnuairePoste() {
    this.toastrService.clear();
    this.toastrDownloadService.showToast('Export en cours');

    this.posteService
      .getAnnuairePoste(0, this.length)
      .pipe(take(1))
      .subscribe({
        next: (result) => {
          if (result) {
            this.dataJSON = result.results;
            this.length = result.totalRecords;
            let _data_export: any[] = [];
            _data_export = this.transformDataListePosteForExport(this.dataJSON);
            this.convertExcel(_data_export, 'export_annuaire_des_postes');

            setTimeout(() => {
              this.toastrDownloadService.downloadSuccess();
            }, 2000);

            this.snackBar.open('Export réussi !', 'Fermer', {
              duration: 4000,
              horizontalPosition: 'right',
              verticalPosition: 'top'
            });
          }
        },
        error: (error) => {
          this.toastrService.clear();
          this.toastrDownloadService.removeToast();

          this.snackBar.open('Erreur lors de l’export', 'Fermer', {
            duration: 5000,
            horizontalPosition: 'right',
            verticalPosition: 'top'
          });
        }
      });
  }

  convertExcel(data: any, name: string) {
    const search = '/';
    const replaceWith = '-';
    const date = new Date().toLocaleDateString('en-GB').split(search).join(replaceWith);
    let fileName = `${name}_${date}`;
    this.excelService.exportToExcel(data, `${fileName}.xlsx`, 'Sheet1');
  }

  viewDetailsAnnuairePoste(data: any) {
    const detenteurs = Array.isArray(data?.detenteurs) ? data.detenteurs : [];

    this.dialog.open(DetailAnnuairePosteComponent, {
      data: { detenteurs },
      width: '960px',
      maxHeight: '800px'
    });
  }
}
